<template>
    <div>
        <section id="service">
            <div>
                <h1 class="mb-4 text-center">Opt-out of {{ client.program_name }}</h1>
            </div>
            <div class="container services-area page">
                <div class="form-item preview">
                    <div class="alert alert-success mb-3">
                        <i class="fa fa-check-circle"></i> Policy Submitted Successfully
                    </div>

                    <div class="alert alert-info text-center mb-5">
                        We will review the information you have submitted and
                        respond within 2-5 business days. An approval or denial letter will
                        be sent to the primary resident’s email address.
                    </div>

                    <h4 class="mb-4">The following information was submitted:</h4>

                    <h5>Property</h5>
                    <hr>
                    <div class="mb-3">{{ form.property_id }}</div>

                    <h5>Resident</h5>
                    <hr>
                    <div class="row mb-3" v-for="(resident, index) in form.residents">

                        <div class="row mb-3" v-if="index === 0">
                            <div class="sub-title">Primary:</div>
                        </div>

                        <div class="col-md-3 form-group mb-3">
                            <p>{{ resident.first_name }}</p>
                        </div>
                        <div class="col-md-3 form-group mb-3">
                            <p>{{ resident.last_name }}</p>
                        </div>
                        <div class="col-md-3 form-group mb-3">
                            <p>{{ resident.email }}</p>
                        </div>
                        <div class="col-md-3 form-group mb-3">
                            <p>{{ resident.tel }}</p>
                        </div>

                        <div class="row" v-if="index === 0 && form.residents.length > 1">
                            <div class="sub-title">Additional:</div>
                        </div>
                    </div>

                    <h5>Address:</h5>
                    <hr>
                    <div class="row">
                        <div class="col-md-6 form-group mb-3">
                            <label>Insured Address 1:</label>
                            <p>{{ form.address_1 }}</p>
                        </div>
                        <div class="col-md-6 form-group mb-3">
                            <label>Insured Address 2:</label>
                            <p>{{ form.address_2 }}</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4 form-group mb-3">
                            <label>City:</label>
                            <p>{{ form.city }}</p>
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <label>State:</label>
                            <p>{{ form.state }}</p>
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <label>Zip:</label>
                            <p>{{ form.zip }}</p>
                        </div>
                    </div>

                    <h5>Policy</h5>
                    <hr>
                    <div class="row">
                        <div class="col-md-4 form-group mb-3">
                            <label>Insurance Provider:</label>
                            <p>{{ form.provider }}</p>
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <label>Policy Number:</label>
                            <p>{{ form.policy_number }}</p>
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <label>Coverage Limit:</label>
                            <p>${{ form.coverage }}</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4 form-group mb-3">
                            <label>Start Date:</label>
                            <p>{{ form.start_date }}</p>
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <label>Effective Date:</label>
                            <p>{{ form.effective_date }}</p>
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <label>End Date:</label>
                            <p>{{ form.end_date }}</p>
                        </div>
                    </div>

                    <h5 v-if="ext !== ''">Attachment</h5>
                    <hr v-if="ext !== ''">
                    <div class="row mb-3" v-if="ext !== ''">
                        <div class="col">
                            <p><i class="fa fa-file"></i> {{ ext }} File(s) received</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
export default {
    metaInfo: { title: 'Opt-Out Confirmation' },
    components: {},
    props: {
        client: Object,
        form: Object,
        ext: String,
    },
    layout: Layout,
    data() {
        return {

        }
    },
    watch: {},
    mounted() {
    },
    methods: {},
    computed: {}
}
</script>
